<script setup lang="ts">
import type { Form } from './types';
import FillForm from './FillForm.vue';
import type { RejectType } from 'vince-core/utils/async';
import { clone } from 'vince-core/utils/objects';

const { t } = useI18n();
let editReject: RejectType;
const visible = ref(false);
const form = ref<Form>();

const show = (f: Form) => {
    form.value = clone(f);
    return new Promise((_resolve, reject) => {
        editReject = reject;
        visible.value = true;
    });
};

const cancel = () => {
    visible.value = false;
    editReject();
};

defineExpose({ show });
</script>
<template>
    <VDialog
        v-model:visible="visible"
        :title="t('formBuilder.previewHeader')"
        class="w-1/3"
        @cancel-action="cancel"
    >
        <template v-if="form">
            <fill-form :form="form" preview />
        </template>
    </VDialog>
</template>
